












































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addAssembly1, queryAssemblyById, updateAssembly } from '@/api/assembly.ts'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private title = '新建轮播图';
  private title1 = '';
  private imageUrl: string = ''
  private actionType: string = 'add'
  private vueRest = '1'
  private index = 0
  private inputStyle = { flex: 1 }
  private titleId = ''
  private titleId1 = ''
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    imgUrl: '',
    hrefUrl: ''
  }

  get rules() {
    return {
      imgUrl: {
        required: true,
        message: '轮播图不能为空'
      },
      hrefUrl: {
        required: true,
        message: '顺序不能为空'
      }
    }
  }

  created() {
    this.titleId1 = this.$route.query.titleId;
    this.title1 = this.$route.query.title;
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改轮播图信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  private async init() {
    queryAssemblyById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.imageUrl = res.data.data.imgUrl
        this.ruleForm.imgUrl = res.data.data.imgUrl
        this.ruleForm.id = res.data.data.id
        this.ruleForm.hrefUrl = res.data.data.hrefUrl
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  cancel() {
    this.$router.push({ path: '/competition/recordingPictureManage', query: { titleId: this.titleId1, title: this.title1 } })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.imgUrl) return this.$message.error('轮播图不能为空')
        if (!this.ruleForm.hrefUrl) return this.$message.error('顺序不能为空')
        // let params: any = { ...this.ruleForm }
        let params: any = {}
        // params.flavors = this.dishFlavors
        params.imgUrl = this.ruleForm.imgUrl
        params.hrefUrl = this.ruleForm.hrefUrl
        params.type = 0
        // params.price *= 100
        if (this.actionType == 'add') {
          params.titleId = this.titleId
          delete params.id
          addAssembly1(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('轮播图添加成功！')
                  this.$router.push({ path: '/competition/recordingPictureManage', query: { titleId: this.titleId1, title: this.title1 } })
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          updateAssembly(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/competition/recordingPictureManage', query: { titleId: this.titleId1, title: this.title1 } })
                this.$message.success('轮播图修改成功！')
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.imgUrl = value
  }
}
